/**
 * Created by Анжелика on 23.08.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import update from "react-addons-update";

const initialState = {
    isFetching: false,
    error: null,
    items: [],
    activeChannel: null,
    formattedChannels: []
};

export function channels(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_CHANNELS_REQUEST:
            return {
                ...state,
                isFetching: true,
                error: null,
                items: [],
                formattedChannels: [],
                activeChannel: null
            };

        case actionTypes.GET_CHANNELS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                error: null,
                items: action.channels,
                formattedChannels: _formatChannels(action.channels, action.genres)
            };

        case actionTypes.GET_CHANNELS_FAILED:
            return {
                ...state,
                isFetching: false,
                error: action.error,
                items: [],
                formattedChannels: [],
                activeChannel: null
            };

        case actionTypes.SET_CHANNEL_ACTIVE:
            return {
                ...state,
                activeChannel: action.channel
            };

        case actionTypes.RESET_CHANNEL_ACTIVE:
            return {
                ...state,
                activeChannel: null
            };

        case actionTypes.MARK_AS_FAVORITE:
            let nextChannels = _favoriteMarkChannels(state.items, action.channel, action.isFavorite);
            return {
                ...state,
                items: nextChannels,
                formattedChannels: _favoriteMarkItems(state.formattedChannels, nextChannels, action.channel, action.isFavorite)
            };

        default:
            return state;
    }
}

function _formatChannels(channels, genres) {
    let Items = [];
    let favorites = [];

    channels.forEach(channel => {
        let genre = genres.find(item => (item.id === channel.groupTitle));
        let genreItemsIndex = Items.findIndex(item => (channel.groupTitle === item.genreId));

        if (genreItemsIndex === -1) {
            let genreChannels = [];
            genreChannels.push(channel);
            let item = {genreId: channel.groupTitle, genreName: genre ? genre.title : '', channels: genreChannels};
            Items.push(item);
        } else {
            let genreChannels = Items[genreItemsIndex].channels;
            genreChannels.push(channel);
            Items[genreItemsIndex].channels = genreChannels;
        }

        if (channel.favorite === 1) {
            favorites.push(channel);
        }
    });

    let favoritesItem = {genreId: 'favorite', genreName: 'Избранное', channels: favorites};
    Items.push(favoritesItem);

    return Items;
}

function _favoriteMarkChannels(channels, channel, isFavorite) {
    const updatedChannel = update(channel, {
        favorite: {$set: isFavorite}
    });
    const channelIndex = channels.findIndex(item => (item.channelID === channel.channelID));
    if (channelIndex !== -1) {
        let updatedChannels = update(channels, {
            $splice: [[channelIndex, 1, updatedChannel]],
        });
        return updatedChannels;
    } else {
        return channels;
    }
}

function _favoriteMarkItems(Items, allChannels, channel, isFavorite) {
    let updatedChannels, nextItems = [];

    Items.forEach(item => {
        if (item.genreId === 'favorite') {
            updatedChannels = allChannels.filter(item => (item.favorite === 1));
        } else {
            updatedChannels = _favoriteMarkChannels(item.channels, channel, isFavorite);
        }
        let nextItem = {...item, channels: updatedChannels};
        nextItems.push(nextItem);
    });

    return nextItems;
}


// WEBPACK FOOTER //
// ./src/reducers/channels.js